function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { forwardRef, styled } from '@grupoboticario/flora-react-system';
var StyledBox = styled('div', {
  boxSizing: 'border-box'
});

/**
 * @component
 * @name Box
 * @description
 * Base component
 * @example
 * <Box as="div" css={{}} />
 * @tutorial https://flora.gb.tech/docs/components/core/box
 */
export var Box = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledBox, _extends({
    ref: forwardedRef
  }, props));
});
//# sourceMappingURL=Box.js.map